export default __webpack_public_path__ + "static/media/ic_back.b48223f1.png";